import axios from 'axios'
import moment from 'moment'
import { BUSCAR_VIAGENS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions';
import { salvarCacheViagens, carregarCacheViagens } from '../../util/offlineStorage';
import { showInfoMsg } from '../../util/messagesUtil';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarViagens (idCidadeOrigem, idCidadeDestino, dataIda, dataVolta, idEmpresa, seEncomenda, buscaNaEmpresaSelecionada, tipoBuscaVeiculo) {
  const dataFormatada = moment(dataIda).format('YYYY-MM-DD');
  let url = `${URL}/passagem/origem/${idCidadeOrigem}/destino/${idCidadeDestino}/dataIda/${dataFormatada}/empresa/${idEmpresa}?buscaTipoVeiculo=${tipoBuscaVeiculo}`;
  if (dataVolta) {
    url += `&dataRetorno=${moment(dataVolta).format('YYYY-MM-DD')}`;
  }
  if (seEncomenda) {
    url += '&encomenda=true';
  }
  if (buscaNaEmpresaSelecionada !== null && buscaNaEmpresaSelecionada !== undefined) {
    url += '&buscaNaEmpresaSelecionada=' + buscaNaEmpresaSelecionada;
  }

  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
    .then(response => {
      salvarCacheViagens(idEmpresa, idCidadeOrigem, idCidadeDestino, dataFormatada, response.data);
      return dispatch({ type: BUSCAR_VIAGENS, payload: response });
    })
    .catch(erro => {
      if (!navigator.onLine || !erro.response) {
        const cache = carregarCacheViagens(idEmpresa, idCidadeOrigem, idCidadeDestino, dataFormatada);
        if (cache) {
          const deveFiltraEmpresa = buscaNaEmpresaSelecionada;
          const deveFiltraTipo = tipoBuscaVeiculo && tipoBuscaVeiculo !== 'TODOS';
          let dados = cache;
          if (deveFiltraEmpresa || deveFiltraTipo) {
            const filtrar = viagens => (viagens || []).filter(v => {
              const passaEmpresa = !deveFiltraEmpresa || v.idEmpresa === idEmpresa;
              const passaTipo = !deveFiltraTipo || v.tipoVeiculo === tipoBuscaVeiculo;
              return passaEmpresa && passaTipo;
            });
            dados = {
              ...cache,
              passagensIda: filtrar(cache.passagensIda),
              passagensRetorno: filtrar(cache.passagensRetorno)
            };
          }
          return dispatch({ type: BUSCAR_VIAGENS, payload: { data: dados } });
        }
        showInfoMsg('Sem conexão. Clique em "Carregar Offline" enquanto estiver online para disponibilizar os itinerários.');
        return dispatch({ type: BUSCAR_VIAGENS, payload: { data: { passagensIda: [], passagensRetorno: [] } } });
      }
      throw erro;
    });
}
